
export function getPlotOptions(percentage) {
  const format = percentage ? '{point.y}%' : '{point.y}';
  const plotOptions = {
    column: {
      pointPadding: 0,
      borderWidth: 0,
      events: {
        legendItemClick: () => {
          return false;
        }
      },
      dataLabels: {
        enabled: true,
        format
      }
    },
  };

  return plotOptions;
}

export function getToolTip(percentage) {
  const label = percentage ? '{point.y}%' : '{point.y}';
  const tooltip = {
    headerFormat: '<span style="z-index: 10"><span style="font-size:10px">{point.key}</span><table>',
    pointFormat: `<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
      '<td style="padding:0"><b>${label}</b></td></tr>`,
    footerFormat: '</table></span>',
    useHTML: true
  };

  return tooltip;
}


// WEBPACK FOOTER //
// ./src/utils/chartHelpers.js